import { cn } from "../lib/cn";

export interface MetricTileProps {
  title: string;
  value: string;
  detail: string;
  tone?: "neutral" | "accent";
  className?: string;
}

export function MetricTile({ className, detail, title, tone = "neutral", value }: MetricTileProps) {
  return (
    <div
      className={cn(
        "flex flex-col gap-1 rounded-xl border border-border bg-card p-4 shadow-sm",
        tone === "accent" && "border-primary/25 bg-primary/5",
        className,
      )}
    >
      <p className="text-xs font-medium text-muted-foreground">{title}</p>
      <p
        className={cn(
          "text-2xl font-semibold tracking-tight tabular-nums",
          tone === "accent" ? "text-primary" : "text-foreground",
        )}
      >
        {value}
      </p>
      <p className="text-xs text-muted-foreground">{detail}</p>
    </div>
  );
}
